import React, { Fragment } from 'react';
import { Box, TextField, Typography } from '@mui/material';

import _ from 'lodash';
import Error from '../../../form/components/Error.component';

const ControlTextField = ({
  item,
  editable,
  onChange = () => {},
  name,
  label,
  currentState,
  visibleText = true,
  type = 'text',
  sx,
  error,
  required = false,
}) => {
  return (
    <Fragment>
      {!editable?.[item?.id] ? (
        visibleText && (
          <Typography>
            {_.has(currentState, `${name}.${item?.id}`)
              ? currentState?.[name]?.[item?.id] || '-'
              : item?.attributes?.[name] || '-'}
          </Typography>
        )
      ) : (
        <Box>
          <TextField
            type={type}
            size='small'
            value={
              _.has(currentState, `${name}.${item?.id}`)
                ? currentState?.[name]?.[item?.id]
                : item?.attributes?.[name] || ''
            }
            sx={{
              '& input': {
                height: '14px',
              },
              marginTop: 1,
              marginBottom: 1,
              ...sx,
            }}
            onChange={(event) =>
              onChange(parseFloat(event?.target?.value || '0'), name, item?.id)
            }
            label={label}
            fullWidth
            error={!!error}
            required={required}
          />
          <Error error={error} />
        </Box>
      )}
    </Fragment>
  );
};
export default ControlTextField;
